var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { buttonVariants, iconStyles, sizeVariants, innerSpanVariants, sizeWithIconVariants, } from './Button.css';
export const renderIcon = (iconComponent) => React.cloneElement(iconComponent, {
    className: cx(iconStyles, iconComponent.props.className),
    weight: 'bold',
});
export const Button = React.forwardRef(function Button(_a, ref) {
    var { as, children, className, iconPrefix, iconSuffix, isDisabled = false, onClick, size = 'large', type, variant = 'secondary' } = _a, rest = __rest(_a, ["as", "children", "className", "iconPrefix", "iconSuffix", "isDisabled", "onClick", "size", "type", "variant"]);
    const Component = as || 'button';
    return (_jsxs(Component, Object.assign({}, rest, { className: cx(buttonVariants[isDisabled ? 'disabled' : variant], iconPrefix || iconSuffix ? sizeWithIconVariants[size] : sizeVariants[size], className), disabled: isDisabled, onClick: onClick, ref: ref, type: type !== null && type !== void 0 ? type : (as ? undefined : 'button'), children: [iconPrefix && renderIcon(iconPrefix), _jsx("span", { className: cx(innerSpanVariants[size]), children: children }), iconSuffix && renderIcon(iconSuffix)] })));
});
